interface PageMetadataProps {
  title: string;
  description?: string;
}

/** Sets the document title (and optional description) for a route. React 19 hoists these to <head>. */
export function PageMetadata({ title, description }: PageMetadataProps) {
  return (
    <>
      <title>{title}</title>
      {description != null ? <meta name="description" content={description} /> : null}
    </>
  );
}
